<template>
  <ShopModel :shop="$props" @save="shop => $emit('save', shop)">
    <li class="relative bg-white py-2 px-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 hover:bg-gray-50">
      <div class="flex justify-between space-x-3">
        <div class="min-w-0 flex-1">
          <a href="#" class="block focus:outline-none">
            <p class="truncate text-sm font-medium text-gray-900">{{ title }}<span class="text-gray-500 font-normal"> ({{ lat }}, {{ lng }})</span></p>
            <p class="truncate text-sm text-gray-500">{{ address }}</p>
          </a>
        </div>
        <span @click.stop="$emit('remove')" class="cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-400 hover:text-red-500 w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </span>
      </div>
    </li>
  </ShopModel>
</template>

<script>

import ShopModel from "./ShopModel"

export default {
  components: {
    ShopModel,
  },
  props: ['lat', 'lng', 'address', 'title', 'description', 'src', 'ranges'],
}

</script>
